import { usePledgeCampaignSearchQuery } from '../data-access/queries';

type UseWCPledgeCampaignDetailsReturn = {
	campaignId?: string;
	endDate?: string;
	isPledgeCampaignDetailsError: boolean;
	isPledgeCampaignDetailsLoading: boolean;
	pledgeContractAddress?: string;
	startDate?: string;
};

type UseWCPledgeCampaignDetailsProps = {
	enabled?: boolean;
};

export const useWCPledgeCampaignDetails = ({
	enabled
}: UseWCPledgeCampaignDetailsProps = {}): UseWCPledgeCampaignDetailsReturn => {
	const { data, isError, isLoading } = usePledgeCampaignSearchQuery({ enabled });

	// We can only have one campaign at a time so we can safely take the first item in array
	const campaign = data?.data[0];

	return {
		campaignId: campaign?.id,
		endDate: campaign?.endingAt,
		isPledgeCampaignDetailsError: isError,
		isPledgeCampaignDetailsLoading: isLoading,
		pledgeContractAddress: campaign?.contractAddress?.value,
		startDate: campaign?.startingAt
	};
};
